import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Typography,
} from '@mui/material';
import { useApiGet } from '../../../utils/httpClient';
import { getLocalChapterResources } from '../../../endpoints/resources';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

const LCResources = ({ id, lcAccess, lcAction }) => {
  const { data: localChapterResources } = useApiGet(
    ['local-chapter-resources', id],
    getLocalChapterResources,
    {
      enabled: true,
      retry: 1,
    },
    { chapterId: id }
  );

  if (!localChapterResources) {
    return <Typography variant="body1">Loading...</Typography>;
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={6} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Resource Quick Links" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/98093b4007a54d1fa9f8107fbbbb406d/latest"
                  label={'Treasurers Monthly Report to Chapter'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/385c8de4732d4c28908bf876575a609c/latest"
                  label={'Treasurers Monthly Report to Chapter (with autocalc)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/c11daa850346413a98eba858e1526701/latest"
                  label={'Template for Minutes of Local Chapter Meeting (Word)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/0af49be73ee2472393820d550ed36f64/latest"
                  label={'Template for Minutes of Local Chapter Meeting (PDF)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/e2bc1d16fe464ee6be6367b2da248831/latest"
                  label={'P.E.O. Constitution'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/e66d734db4204bf7b8825d67d9317730/latest"
                  label={'Local Chapter Supply Order Form (PDF)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://eorders.peointernational.org/"
                  label={'Official Emblem Order Form (Online)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/98df44497b204c4da4be9fdff573807e/latest"
                  label={'Official Emblem Order Form (Word)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/af9f1c51cc4e47abb3edcacab6146f56/latest"
                  label={
                    "Corresponding Secretary's Month Report to Chapter (Word)"
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library"
                  label={'Search P.E.O. Resource Library on the Hub'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Instructions to Officers of Local Chapters (IOLC)" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/002cf1dc24ed44d0bb13a9932d8b0ec0/latest"
                  label={'Complete IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/3791a6c8f3914576986c0dd3ea70bdeb/latest"
                  label={'President IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/96518cd2be574d57bbdadc398e83c62e/latest"
                  label={'Vice President IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/058f3142a00a48bf80170f602cf7aafe/latest"
                  label={'Recording Secretary IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/69a14366329941ad84a6e7bd2b710db3/latest"
                  label={'Corresponding Secretary IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/7064e665781a44c6b2ea7f10ef236683/latest"
                  label={'Treasurer IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/b3689eda514348d99473a990f4866e28/latest"
                  label={'Chaplain IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/41cbb8546cf441dc8c850686bd6a1042/latest"
                  label={'Guard IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/1144d77e69d346eb8e5706f9a10d8546/latest"
                  label={'IOLC Policies'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library/document/b0dacb94d9c54888a8c32d0ee1bdb651/latest"
                  label={'IOLC Exhibits'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {lcAction && (
        <Grid item xs={12} sm={6} padding paddingTop={5}>
          <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
            <CardHeader title="Annual Report Items" />
            <CardContent>
              <Grid container>
                <Grid item xs={12}>
                  <ButtonLink
                    href={`/roster/${localChapterResources.roster_form_id}`}
                    label={'View 2025 Roster and Dues Form'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonLink
                    href={`/irs/${localChapterResources.irs_form_id}`}
                    label={'View 2025 IRS-LC Form'}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default LCResources;
